import Jumbotron from './Jumbotron';
const WebSys = () => {
  return (
    <>
      <Jumbotron />
      <div className="page-padd mt-4">
        <div className="accordion" id="accordionExample">
          <div className="card">
            <div className="card-header p-0" id="headingOne">
              <h2 className="mb-0">
                <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Course Overview
                </button>
              </h2>
            </div>

            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div className="card-body">
                <h5>Syllabus</h5>
                <div className="panelwrapper htmlmodule" id="ctl01_mainContent_ctl00_pnlWrapper">
                  <a id="module93"></a>
                  <div className="modulecontent">
                    <div className="slidecontainer" id="ctl01_mainContent_ctl00_divContent">
                      <div>State University of New York at Old Westbury</div>
                      <div>School of Business</div>
                      <div>Instructor: Dr. Alireza Ebrahimi</div>
                      <div>BU4035– Web Systems &amp; E-Commerce</div>
                      <div>Office: NAB 0071</div>
                      <div>Office Hours: Tuesday &amp; Thursdays: 1pm-2:30pm in NAB 0071, Monday: 11:30am-1pm, or by appointment</div>
                      <div>Phone: Cell 917-279-4432 (preference 11am-11pm)</div>
                      <h4>
                        Email: <a href="mailto:ebrahimia@oldwestbury.edu">ebrahimia@oldwestbury.edu</a> &amp;{" "}
                        <a href="mailto:ebrahimidr@gmail.com" style={{ fontSize: '11.2px' }}>ebrahimidr@gmail.com</a>
                      </h4>
                      <h4>
                        Website: <a href="http://www.drebrahimi.com">www.drebrahimi.com</a> &amp;{" "}
                        <a href="http://www.ebrahimialireza.com/" style={{ fontSize: '11.2px' }}>www.ebrahimialireza.com</a>
                      </h4>

                      <div><strong>Text Book:</strong> <em>Creating a Web Site: The Missing Manual</em>, Second Edition By: Matthew MacDonald, Publisher: O'Reilly Media, December 2008, ISBN: 978-0-596-52097-7</div>
                      <div>Website: <a href="https://managementhelp.org/computers/e-commerce.htm">Basic Guide to E-Commerce</a></div>

                      <div><strong>Bibliography:</strong> C++ PROGRAMMING: EASY WAYS VOLUME TWO, Alireza Ebrahimi, American Press</div>

                      <h4>A.1. Course Description</h4>
                      <div>This course covers the basics of Web Systems and the development of e-commerce applications and systems.</div>

                      <h4>A.2. Intended Audience</h4>
                      <div>Business Administration-General</div>

                      <h4>A.3. Course Objectives</h4>
                      <div>The objective of this course is to help students understand different web technologies and systems.</div>

                      <h4>A.4. Course Learning Goals</h4>
                      <div>Students will be able to design a high-quality e-commerce system based on 7x2C criteria.</div>

                      <h4>B. Prerequisites:</h4>
                      <div>BU3015</div>

                      <h4>C. Mode of Instruction:</h4>
                      <div>The class consists of both lecture and lab. During the lab, there will be demonstrations using Internet and web technologies.</div>

                      <h4>D. Student Responsibilities:</h4>
                      <ol>
                        <li>Each student will be expected to complete a web project.</li>
                        <li>There will be a test, midterm, and final exam.</li>
                        <li>Students must plan to spend a minimum of two hours per week outside of class on computer work.</li>
                      </ol>

                      <h4>Attendance Policy:</h4>
                      <div>Excessive absences and habitual tardiness can affect performance and the final grade.</div>

                      <h4>Incomplete:</h4>
                      <div>A grade of Incomplete (I) may be assigned by the instructor when extenuating circumstances make it impossible to complete the course.</div>

                      <h4>Withdrawals:</h4>
                      <div>Students wishing to withdraw after the seventh week must deliver a signed request to the Registrar. Last day to withdraw is April 29, 2010.</div>

                      <h4>E.1. Grading:</h4>
                      <table border="1" cellPadding="0" cellSpacing="0">
                        <tbody>
                          <tr>
                            <td>Discussions:</td>
                            <td>At least 4 entries per module, 7 modules</td>
                            <td>35%</td>
                          </tr>
                          <tr>
                            <td>Writing Assignments:</td>
                            <td>5 assignments at 5% each</td>
                            <td>25%</td>
                          </tr>
                          <tr>
                            <td>Midterm and Final:</td>
                            <td>Midterm 10%, Final 10%</td>
                            <td>20%</td>
                          </tr>
                          <tr>
                            <td>Quizzes:</td>
                            <td>4 quizzes at 5% each</td>
                            <td>20%</td>
                          </tr>
                          <tr>
                            <td>Total</td>
                            <td>&nbsp;</td>
                            <td>100%</td>
                          </tr>
                        </tbody>
                      </table>

                      <div>The numerical average will determine the final grade:</div>
                      <div>90-100 = A, 80-89 = B, 70-79 = C, 60-69 = D, 59 and under = F</div>

                      <h4>E.2. Missed Exams:</h4>
                      <div>Missed exams will not have a makeup unless a valid excuse is given. Only one makeup exam will be provided.</div>

                      <h4>Academic Misconduct:</h4>
                      <div>Handing in someone else’s work or copying during exams is a violation of the Student Code of Conduct.</div>

                      <h4>Academic Integrity:</h4>
                      <div>Students are expected to maintain high standards of honesty in their academic work.</div>

                      <h4>Cheating:</h4>
                      <div>Cheating includes unauthorized information sharing during any academic assessment.</div>

                      <h4>Plagiarism:</h4>
                      <div>Plagiarism is using material from another author without properly citing the source.</div>

                      <h4>F. Accommodations for Students with Special Needs:</h4>
                      <div>If you have a disability that may impact your coursework, contact Dr. Lisa Whitten at the Office of Services for Students with Disabilities.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
        <div className="card">
          <div className="card-header p-0" id="heading01">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse01" aria-expanded="false" aria-controls="collapse01">
                Module One
              </button>
            </h2>
          </div>
          <div id="collapse01" className="collapse" aria-labelledby="heading01" data-parent="#accordionExample">
            <div className="card-body">
              <h5>Assignment 1</h5>
              <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                <p>
                  Hello! You may have never built a web page before. Here’s how we are going to start building a web page using HTML (Hyper Text Markup Language). Please read the materials in this module and type the provided HTML tags as-is into a text editor such as Notepad, WordPad, FrontPage, or any text editor you are familiar with.
                </p>
                <p>
                  Save the typed code as <strong>index.html</strong> on the desktop (or another location you prefer). To activate your web page, go to the desktop and click on <strong>index.html</strong>. You have created a web page on your own computer, but it’s not yet complete (some tags may be missing or incorrectly formatted, such as the image <code>src</code>). Additionally, it’s not accessible from other computers on the internet.
                </p>
                <p>
                  Type the HTML code provided in Module One as it is and view it. The next step is to fix any issues and customize it to your liking. For example, the image might not show if the link is incorrect. In the next assignment, you will fix these issues and customize the page to create a web page for an e-commerce service.
                </p>
                <p>
                  To submit your assignment, capture a screenshot of your web page and paste it into a Word document. Make sure to save the document as <strong>yourname.doc</strong> and submit it as an attachment.
                </p>
              </div>
              <h5>Discussion 1</h5>
              <p>
                Please discuss with each others ways of creating your web page according the 10 HTML commandment for the first assignment. 35% of the course grade has been set for the discussions through the term. We are going to have 7 modules including the final module for the submission of the final project and the posting of the all your discussions
              </p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-0" id="headingTwo">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Module Two
              </button>
            </h2>
          </div>
          <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
            <div className="card-body">
              <h5>Assignment 2</h5>
              <div id="ctl01_mainContent_ctl00_divContent" className="slidecontainer">
                <p><strong>Step 1:</strong> Get a domain name (average cost is $10 per year).</p>
                <p><strong>Step 2:</strong> Get web hosting (average cost is $5 per month).</p>
                <p>
                  <em>Note:</em> Please choose a provider with <u>FrontPage Extension</u> or <u>Expression Extension</u> support, as it makes live manipulation easier.
                </p>
                <p><strong>Step 3:</strong> Manage your site (e.g., directory) via FrontPage, Expression, or FTP.</p>
                <p>
                  <em>Note:</em> When working with FTP, you will need to upload files from your computer to the website. After making changes locally, you may need to re-upload files to keep the website updated.
                </p>
                <p>There are also free web hosting and domain redirection options you can explore.</p>
              </div>
              <h5>Discussion 1</h5>
              <p>
                Discuss the necessary changes that is required to build an e-commerce tutorial system. For example give your own name, having lesson 1, lesson 2, etc.. links. You may want to have images and other feature discussed in the 10 commandments. You may want to look at other tutorial systems. Remember that this is your first attempt.
              </p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-0" id="headingThree">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Module Three
              </button>
            </h2>
          </div>
          <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
            <div className="card-body">
              <h5>Assignment 3</h5>
              <p>Convert and customized  the "web page AS IS" of the first assignment to a web page that provides a tutorial service. The course project will be to design an e-commerce web page for C++ programming Tutorial (I know that you don't know programming and the language C++). The tutorial material will be provided to you or you can find it on your own. You can look at www.drebrahimi.com, and Programming Easy Ways C++. I understand that this is a first attempt but the material in your page should convey that is a C++ programming tutorial.
              In addition try to include your own creativity.</p>
              <p>However you have a choice to design other web pages but you need to inform me ahead as how you are going to provide the resources.</p>
            <h5>Discussion 3</h5>
            <p>Discuss how to evaluate a web page based on 7x2 C evaluations according to the article above.</p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-0" id="headingFour">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                Module Four
              </button>
            </h2>
          </div>
          <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
            <div className="card-body">
              <h5>Assignment 4</h5>
              <p>In one page report explain the criteria for evaluation of the college web pages (7 x 2 C). Add to your paper two citation and references to evaluate a web page.</p> <br /> <br />
              <p>You are assigned to analyse 6 Faculty Senates web pages of 64 SUNY campuses (you may choose other business web pages but please let me know). You should rank the highest to the lowest and the reason why you think so. Attach 1 page of each web site in your word document. Write a 1-2 page report including your introduction.</p>
              <h5>Discussion 4</h5>
              <p>Discuss the selected web pages from the point of 7x2 C analysis. Why a web page was the best and what was your criteria. Ask a question or answer a question. Make sure to have at least 4 postings.</p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-0" id="headingFive">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                Module Five
              </button>
            </h2>
          </div>
          <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
            <div className="card-body">
              <h5>Assignment 5</h5>
              <p>Pick up 5 tutorial websites and evaulate them according to the criteria of 7 x 2C, and indicate why a webpage is the best and why one is the worst. The site should be C++ material, however other  programming  languages such as visual basis, perl, java, javascript, and html can be considered. In addition you can choose other tutorial subjects such as math, physics and other natural languages. </p>
              <h5>Discussion 5</h5>
              <p>Discuss your selection of your web pages as well as how to down load mojo portal (predefined template ) to your webosting and start a new way to design your web business.  please look at my site and get some ideas. Please have at least 4 posts.</p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-0" id="headingSix">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                Module Six
              </button>
            </h2>
          </div>
          <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
            <div className="card-body">
            <h5>Assignment 6</h5>
            <p>CGI Reveiw</p>
            <h5>Discussion 6</h5>
            <p>Discuss Javascript and how to integrate a javascript program into your webpage</p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-0" id="headingSeven">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                Module Seven
              </button>
            </h2>
          </div>
          <div id="collapseSeven" className="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
            <div className="card-body">
            <h5>Assignment 7</h5>
            <p>1) Submit Paper - criteria to study a webpage and study of 5 web pages based on 7x2C. The paper should be readable, like a story and at the end there should be references and appendix as a separate file (because Angel may not let you submit a large file). Define the criteria and provide at  one example for your website. Pick the best web page and explain why this page is the best and similarly do the same for the worst website and explain. </p>
            <p>2)   C++ Programming Tutorial System (your final web page). You should provide your website link (URL), you should take a screenshot (10 pages) of your website demonstrating 7x2 features in your websites (70pts on webpage is based on 7x2c criteria), take a snapshot of your index and other web file code to identify 10 major html code (possibly 10th commandment in the first homework) your have learned (10pts-for example a href ). Provide a snapshot demonstrating inclusion of JavaScript program in your website (10pts- JavaScript) (For example a simple search engine or date ). Provide a snapshot demonstrating either incorporation of server programming like CGI or extra features that make your website compelling and fancy (10pts- CGI or fancy features).</p>
            <h5>Discussion 7</h5>
            <p>Submit you web site and your evaluation paper - make your web fancy -  add a server program such cgi or php perl etc..</p>
            </div>
          </div>
        </div>
        </div>
        <div className="mt-3">
          <iframe frameBorder="0" height="300" title="myFrame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
            className="iframeStyle">
          </iframe>
        </div>
      </div >
    </>
  );
}

export default WebSys;